import { Box, type SxProps, Typography } from '@mui/material';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { BankingReviewsEyebrow } from './BankingReviewsEyebrow';

type HeaderProps = {
  title: string;
  stateForEyebrow?: StateAbbreviation;
  disclosureSectionTitle?: string;
  showBestOf?: boolean;
  sx?: SxProps;
};

export const PageHeader: React.FC<HeaderProps> = ({
  title,
  stateForEyebrow,
  disclosureSectionTitle,
  showBestOf,
  sx = {},
}) => {
  return (
    <Box>
      {showBestOf && (
        <Typography variant="accentSmall" sx={{ marginBottom: 2 }}>
          best of {!!disclosureSectionTitle && `- ${disclosureSectionTitle}`}
        </Typography>
      )}
      <BankingReviewsEyebrow stateForEyebrow={stateForEyebrow} />
      <Typography variant="xlHeadline" component="h1" sx={sx}>
        {title}
      </Typography>
    </Box>
  );
};
